/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

import {HttpClientModule} from "@angular/common/http";

import {OverlayModule} from "@angular/cdk/overlay";

import {MatProgressSpinnerModule, MatSpinner} from "@angular/material/progress-spinner";

import {AppRoutingModule} from "./app-routing.module";
import {PlatformModule} from "./platform/platform.module";

import {AppComponent} from "./app.component";
import {MAT_DATE_LOCALE} from "@angular/material/core";
import {AigiaModule} from "./aigia/aigia.module";
import { FlexLayoutModule } from '@angular/flex-layout';


@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		CommonModule,
		BrowserModule,
		BrowserAnimationsModule,

		AppRoutingModule,
		HttpClientModule,
		OverlayModule,

		MatProgressSpinnerModule,

		AigiaModule,
		PlatformModule,
		FlexLayoutModule,


 // 		ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
	],
	providers: [
		{provide: MAT_DATE_LOCALE, useValue: 'ja-JP'},
	],
	bootstrap: [AppComponent],
	entryComponents: [
		MatSpinner,
	],
})

export class AppModule {
}
